import React from 'react';
import { RootStack } from 'src/navigation/RootNavigation';
import withSuspense from 'src/navigation/withSuspense';
const DebugSettings = withSuspense(React.lazy(() => import('./screens/DebugSettings')));
export const renderDebugStackRoutes = ({}) => {
    return (React.createElement(RootStack.Group, null,
        React.createElement(RootStack.Screen, { name: "Debug_Settings", component: DebugSettings })));
};
